import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_e185b7e9 from '../styles/Skeleton.module.less.js';

/**
 * @description Provide a placeholder while you wait for content to load, or to visualise content that doesn't exist yet
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton />
 * ```
 */
const Skeleton = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_e185b7e9);
    const classNames = cx(className, 'container');
    return (React.createElement("div", { ref: ref, "data-qa": "Skeleton", className: classNames, ...restProps }, children));
});
Skeleton.displayName = 'Skeleton';

export { Skeleton };
//# sourceMappingURL=Skeleton.js.map
